import { render, staticRenderFns } from "./ClaimProfile.vue?vue&type=template&id=34b9102c&scoped=true&"
import script from "./ClaimProfile.vue?vue&type=script&lang=js&"
export * from "./ClaimProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClaimProfile.vue?vue&type=style&index=0&id=34b9102c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b9102c",
  null
  
)

export default component.exports